import { INSTAGRAM_URL } from '../constants';
import { gsap, useMotion } from '../lib/motion';

const photos = [
  { src: "/trabalhos/bohemian-knotless.jpg", alt: "Bohemian knotless braids com mechas cacheadas", w: 640, h: 853 },
  { src: "/trabalhos/big-braids.jpg", alt: "Big braids", w: 640, h: 890 },
  { src: "/trabalhos/lemonade-braids.jpg", alt: "Lemonade braids", w: 640, h: 880 },
  { src: "/trabalhos/island-twist.jpg", alt: "Island twist", w: 640, h: 671 },
  { src: "/trabalhos/fulani-barrel-twist.jpg", alt: "Fulani barrel twist masculino", w: 640, h: 919 },
  { src: "/trabalhos/passion-locs.jpg", alt: "Passion locs", w: 640, h: 853 },
  { src: "/trabalhos/nago-cachos.jpg", alt: "Trança nagô com cachos", w: 640, h: 876 },
  { src: "/trabalhos/invisible-locs.jpg", alt: "Invisible locs", w: 640, h: 842 },
  { src: "/trabalhos/slim-braids.jpg", alt: "Slim braids", w: 640, h: 853 },
];

const desktopColumns = [0, 1, 2].map((col) => photos.filter((_, i) => i % 3 === col));

function Photo({ photo, index }) {
  return (
    <div data-media className="overflow-hidden rounded-2xl" data-testid={index !== undefined ? `portfolio-item-${index}` : undefined}>
      <img src={photo.src} alt={photo.alt} width={photo.w} height={photo.h} loading="lazy" className="w-full h-auto" />
    </div>
  );
}

export default function Portfolio() {
  const scope = useMotion((root, { desktop }) => {
    if (!desktop) return;
    // Colunas em velocidades diferentes: a do meio desce enquanto as laterais sobem.
    const grid = root.querySelector('[data-columns]');
    root.querySelectorAll('[data-column]').forEach((column, i) => {
      const distance = i === 1 ? 90 : -60;
      gsap.fromTo(
        column,
        { y: -distance },
        { y: distance, ease: 'none', scrollTrigger: { trigger: grid, start: 'top bottom', end: 'bottom top', scrub: 1 } }
      );
    });
  });

  return (
    <section ref={scope} id="portfolio" data-testid="portfolio-section" className="bg-raised border-y border-rule overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
        <div className="mb-10 md:mb-14 lg:mb-24">
          <h2 data-lines className="text-4xl md:text-5xl font-extrabold tracking-tight leading-none text-ink mb-4">
            Trabalhos recentes
          </h2>
          <p data-rise="0.2" className="text-soft leading-relaxed max-w-[60ch]">
            Clientes atendidas no salão da Vila União.{' '}
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-ink font-semibold underline decoration-tan decoration-2 underline-offset-4 hover:text-tan"
              data-testid="instagram-portfolio-link"
            >
              Mais no Instagram
            </a>
          </p>
        </div>

        {/* Celular e tablet: 2 colunas corridas */}
        <div className="portfolio-grid lg:hidden" data-testid="portfolio-grid">
          {photos.map((photo, i) => (
            <div key={photo.src} className="portfolio-item">
              <Photo photo={photo} index={i} />
            </div>
          ))}
        </div>

        {/* Desktop: 3 colunas com parallax */}
        <div data-columns className="hidden lg:grid grid-cols-3 gap-4 items-start">
          {desktopColumns.map((column, i) => (
            <div key={i} data-column className="grid gap-4">
              {column.map((photo) => (
                <Photo key={photo.src} photo={photo} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
